<template>
  <div :class="{ 'fade-in': isLoaded }" class="container">
    <ConnectivityChecker>
      <template v-slot="{ isOnline }">
        <p v-if="!isOnline">Please check your internet connection or VPN. Try reloading the page. If the issue persists, try again later.</p>
      </template>
    </ConnectivityChecker>
    <main id="dashboard">
      <MainNav v-if="isLoaded && router.currentRoute.value.path !== '/login' && router.currentRoute.value.path !== '/auth/callback'" />
      <RouterView />
    </main>
    <DialogHost />
  </div>
</template>

<script>
import { useRouter,RouterView } from "vue-router";
import { useUserStore } from "./store/user.js";
import { watch } from "vue";
import MainNav from "./components/layout/MainNav.vue";
import ConnectivityChecker  from "./components/common/ConnectivityChecker.vue";
import DialogHost from "./components/common/DialogHost.vue";
import { initTranslations } from "./helper/i18n.js";
import { startSessionHeartbeat, stopSessionHeartbeat } from "./composables/useDirectus.js";


export default {
    components: {
      RouterView,
      MainNav,
      ConnectivityChecker,
      DialogHost
    },
    data() {
      return {
        isLoaded: false,
        online: false
      };
    },
    methods: {
      setTheme(theme) {
        const html = document.querySelector("html");
        html.setAttribute("data-theme", theme);
      }
    },
    watch: {
      userStore: {
        handler() {
          if( this.userStore.user ){

            // Read language from localStorage (independent from Directus)
            // Fall back to userStore.user.language if localStorage is empty
            let language = localStorage.getItem('orbit_language') || this.userStore.user.language;
            let locallanguage = this.$i18n.locale;

            if( language === "de-DE"){
              if( locallanguage !== "de-DE"){
                this.$i18n.locale = 'de-DE';
              }
            }

            if( language === "en-US"){
              if( locallanguage !== "en-EN"){
                this.$i18n.locale = 'en-EN';
                this.$i18n.timezone = "en-EN";

              }
            }

            // Load translations from Directus when user is authenticated
            initTranslations();
          }
        },
        deep: true,
        immediate: true
      },
    },
    setup() {
    	const userStore = useUserStore();
      const router = useRouter();

      watch(() => userStore.isLoggedIn, (isLoggedIn) => {
        if (isLoggedIn) {
          startSessionHeartbeat();
        } else {
          stopSessionHeartbeat();
          const path = window.location.pathname;
          if (path !== '/login' && path !== '/auth/callback') {
            router.push('/login');
          }
        }
      });

    	return { userStore,router };
  	},
    mounted() {
      // Initialize theme from localStorage
      const savedTheme = localStorage.getItem('theme') || 'light';
      this.setTheme(savedTheme);

      setTimeout(() => {
        this.isLoaded = true;
      }, 100);

    }
}
</script>

<style>

  .modal-open{
    overflow: hidden;
  }

  body{
    overflow-x: hidden;
    box-shadow: inset 0px -1px 10px 1px #0000002e;
    border-radius: 10px;
  }

  .sidebarNav{
    -webkit-app-region: drag;
  }

  .full-image{
    -webkit-app-region: drag;
  }

  .cs-breadcrumbs{
    -webkit-app-region: drag;
  }

  a{
    -webkit-app-region: no-drag;
  }

  input{
    -webkit-app-region: no-drag;
  }

  *, *::before, *::after {
    position: unset; 
  }

  [data-theme="dark"] .formkit-help,
  [data-theme="dark"] .formkit-input {
    color: var(--cs-white)
  }

  [data-theme="dark"] option {
    color: var(--cs-black)
  }

  .container{
    opacity: 0;
  }

  .fade-in {
    opacity: 1;
    transition: opacity 1s;
  }

  @font-face {
    font-family: 'Material Symbols Outlined';
    font-style: normal;
    font-weight: 400;
    src: url('/materials.woff2') format('woff2');
  }

  .material-symbols-outlined {
      font-family: 'Material Symbols Outlined';
      font-weight: normal;
      font-style: normal;
      font-size: 24px;
      line-height: 1;
      letter-spacing: normal;
      text-transform: none;
      display: inline-block;
      white-space: nowrap;
      word-wrap: normal;
      direction: ltr;
      -webkit-font-feature-settings: 'liga';
      -webkit-font-smoothing: antialiased;
  }



  
</style>
